export enum PageModeEnum {
    Create = "Create",
    Edit = "Edit"
}